import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('expenseLineItem', 'expenseLineItems');

const customActions = {
  async LOAD_expenseLineItems({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('expenseLineItems')
      .query({ $filter: 'IsDeleted eq false', $expand: 'ExpenseDocument' });
    commit('SET_expenseLineItems', data);
  },
  async LOAD_pettyCashAdvanceDocumentLines({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('expenseLineItems')
      .query({
        $expand: 'ExpenseDocument',
        $filter: "ExpenseDocument/DocumentType eq 'pettyCashAdvanceDocument'",
      });
    commit('SET_pettyCashAdvanceDocumentLines', data);
  },
  async LOAD_pettyCashDocumentLines({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('expenseLineItems')
      .query({
        $expand: 'ExpenseDocument',
        $filter: "ExpenseDocument/DocumentType eq 'receiptDocument'",
      });
    commit('SET_pettyCashADocumentLines', data);
  },
};

export default { ...actions, ...customActions };
